import { Api } from "../config/request";
export default {
  getCallDepartmentsList(body) {
    return Api.post(`/logistics-support/support-departments`, body);
  },
  getCallDepartmentDetails(id) {
    return Api.get(`/logistics-support/support-department/${id}`);
  },
  upsertCallDepartments(body) {
    return Api.put("/logistics-support/upsert-support-department", body);
  },
  callDepartmentLanguageRemoteSearch(startsWith, page) {
    return Api.get(`/drivers/languages?page=${page}&startswith=${startsWith}`);
  },
};
